export const TOUCH_QUERY = '(hover: none)';

export const DEFAULT_DELAY_SHOW_MS = 0;

export const DEFAULT_DELAY_HIDE_MS = 0;

export const DEFAULT_HOVER_DELAY_HIDE_MS = 100;

export const VISIBILITY_CHECK_INTERVAL_MS = 100;

export const COLLISION_PADDING_PX = 16;

export const ARROW_WIDTH_PX = 12;

export const ARROW_HEIGHT_PX = 4;

export const ARROW_EDGE_PADDING_PX = 10;

export const ARROW_CENTER_FROM_EDGE_PX = 22;

export const ARROW_CENTER_FROM_SIDE_EDGE_PX = 18;
